import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const SignUp = ({ onToggleForm }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    username: '',
    full_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { signUp } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    const { error } = await signUp(formData.email, formData.password, {
      username: formData.username,
      full_name: formData.full_name,
      avatar_url: null
    });

    if (error) {
      setError(error.message);
    } else {
      alert('¡Registro exitoso! Revisa tu email para confirmar tu cuenta.');
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      {/* Columna izquierda - Video de demostración */}
      <div className="auth-demo-section">
        <div className="demo-content">
          <h1 className="demo-title">Únete a JAM CIRCLE</h1>
          <p className="demo-subtitle">
            Crea tu cuenta y comienza a disfrutar de todas las funcionalidades
          </p>

          <div className="video-container">
            <a
              href="https://collection.cloudinary.com/diysqyres/bcce9ecc2314d77a6b9a6534b6f1fbbe"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '400px',
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                borderRadius: '16px',
                color: 'white',
                textDecoration: 'none',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ fontSize: '80px', marginBottom: '20px' }}>🎬</div>
              <h3 style={{ fontSize: '24px', marginBottom: '10px', fontWeight: 'bold' }}>
                Ver Video Demo
              </h3>
              <p style={{ fontSize: '16px', opacity: 0.8 }}>
                Haz clic para ver cómo funciona JAM CIRCLE
              </p>
              <div style={{
                marginTop: '20px',
                padding: '12px 30px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 'bold'
              }}>
                ▶ Reproducir Demo
              </div>
            </a>
          </div>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🎵</span>
              <span className="feature-text">Crea y comparte playlists</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎤</span>
              <span className="feature-text">Publica tus letras favoritas</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">👥</span>
              <span className="feature-text">Conecta con amigos</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">⭐</span>
              <span className="feature-text">Califica y comenta canciones</span>
            </div>
          </div>
        </div>
      </div>

      {/* Columna derecha - Formulario de registro */}
      <div className="auth-form-section">
        <div className="auth-form">
          <h2 className="auth-form-title">Crear Cuenta</h2>
          <p className="auth-form-description">Completa el formulario para registrarte</p>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="tu@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="tunombredeusuario"
              />
            </div>

            <div className="form-group">
              <label htmlFor="full_name">Nombre completo</label>
              <input
                type="text"
                id="full_name"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="Tu Nombre Completo"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="••••••••"
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmar contraseña</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                disabled={loading}
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="auth-submit-button"
            >
              {loading ? 'Registrando...' : 'Crear Cuenta'}
            </button>
          </form>

          <div className="auth-toggle">
            <p>
              ¿Ya tienes cuenta?{' '}
              <button type="button" className="link-button" onClick={onToggleForm}>
                Inicia sesión aquí
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;